import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { switchDataSet } from '@redux/actions/AuthActions';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import Button from '@material-ui/core/Button';

import {
  REVENUE_CAGR_A,
  REVENUE_CAGR_B,
  REVENUE_GROWTH_A,
  REVENUE_GROWTH_B,
  GROSS_MARGIN_A,
  GROSS_MARGIN_B,
  EBITDA_MARGIN_A,
  EBITDA_MARGIN_B,
  EBITA_MARGIN_A,
  EBITA_MARGIN_B,
  NOPAT_MARGIN_A,
  NOPAT_MARGIN_B,
  CAPEX_REVENUE_A,
  CAPEX_REVENUE_B,
  WRC_REVENUE_A,
  WRC_REVENUE_B,
  NETDEBT_EBITDA_A,
  NETDEBT_EBITDA_B,
  UNLEVEREDFCF_EBITDA_A,
  UNLEVEREDFCF_EBITDA_B,
  MEASUREMENTS_PEER_OP_METRICS1,
  MEASUREMENTS_PEER_OP_METRICS2,
  YEARS
} from '../fakedata2';

const StyledTableCell = withStyles((theme) => ({
  body: {
    borderBottom: 'none !important',
    fontSize: 12,
    lineHeight: 0,
    padding: '3px 15px 3px 16px'
  }
}))(TableCell);

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    fontWeight: 'bold',
    color: '#6D7278',
    minWidth: 225
  },
  body: {
    borderBottom: 'none !important',
    fontSize: 12,
    fontWeight: 'bold',
    padding: '3px 15px 3px 16px'
  }
}))(TableCell);

const TableCellTitle = withStyles((theme) => ({
  body: {
    fontSize: 12,
    borderBottom: 'none !important'
  }
}))(TableCell);

const TableCellTitleStrong = withStyles((theme) => ({
  body: {
    fontSize: 12,
    borderBottom: 'none !important',
    fontWeight: 'bold'
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    // backgroundColor: 'rgba(151,151,151,0.1)'
    // border: '2px solid rgba(151,151,151,0.2)'
  }
}))(TableRow);

const StyledTableRowStrong = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(151,151,151,0.1)'
    // border: '2px solid rgba(151,151,151,0.2)'
  }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700
  },
  tableContainer: {
    borderTop: '5px solid #2DB9C4'
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    '& h2': {
      fontSize: 20,
      fontWeight: 'bold'
    }
  }
}));

const TableIncome = ({ dataSet }) => {
  const [revenueCagr, setRevenuCagr] = useState(REVENUE_CAGR_A);
  const [revenueGrowth, setRevenueGrowth] = useState(REVENUE_GROWTH_A);
  const [grossMargin, setGrossMargin] = useState(GROSS_MARGIN_A);
  const [ebitdaMargin, setEbitdaMargin] = useState(EBITDA_MARGIN_A);
  const [ebitaMargin, setEbitaMargin] = useState(EBITA_MARGIN_A);
  const [nopatMargin, setNopatMargin] = useState(NOPAT_MARGIN_A);
  const [capexRevenue, setCapexRevenue] = useState(CAPEX_REVENUE_A);
  const [netDebtEbitda, setNetDebtEbitda] = useState(NETDEBT_EBITDA_A);
  const [wrcRevenue, setWrcRevenue] = useState(WRC_REVENUE_A);
  const [unleveredFcf, setUnleveredFcf] = useState(UNLEVEREDFCF_EBITDA_A);

  const classes = useStyles();

  useEffect(() => {
    setRevenuCagr(dataSet === 'dataA' ? REVENUE_CAGR_B : REVENUE_CAGR_A);
    setRevenueGrowth(dataSet === 'dataA' ? REVENUE_GROWTH_B : REVENUE_GROWTH_A);
    setGrossMargin(dataSet === 'dataA' ? GROSS_MARGIN_B : GROSS_MARGIN_A);
    setEbitdaMargin(dataSet === 'dataA' ? EBITDA_MARGIN_B : EBITDA_MARGIN_A);
    setEbitaMargin(dataSet === 'dataA' ? EBITA_MARGIN_B : EBITA_MARGIN_A);
    setNopatMargin(dataSet === 'dataA' ? NOPAT_MARGIN_B : NOPAT_MARGIN_A);
    setCapexRevenue(dataSet === 'dataA' ? CAPEX_REVENUE_B : CAPEX_REVENUE_A);
    setNetDebtEbitda(dataSet === 'dataA' ? NETDEBT_EBITDA_B : NETDEBT_EBITDA_A);
    setWrcRevenue(dataSet === 'dataA' ? WRC_REVENUE_B : WRC_REVENUE_A);
    setUnleveredFcf(
      dataSet === 'dataA' ? UNLEVEREDFCF_EBITDA_B : UNLEVEREDFCF_EBITDA_A
    );
  }, [dataSet]);

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <div className={classes.header}>
        <h2>PEER OPERATING METRICS</h2>
      </div>

      <Table
        aria-label="customized table"
        className={classes.table}
        size="small">
        <TableHead>
          <StyledTableRow>
            <StyledTableCellStrong align="left">PEER</StyledTableCellStrong>
            {MEASUREMENTS_PEER_OP_METRICS1.map((measure) => (
              <StyledTableCellStrong align="center">
                {measure}
              </StyledTableCellStrong>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <TableCellTitle />
            <StyledTableCell>
              {YEARS[0].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>Lyft</TableCellTitle>
            <StyledTableCell>
              {revenueCagr[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {revenueGrowth[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {grossMargin[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitdaMargin[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitaMargin[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>Uber Technologies</TableCellTitle>
            <StyledTableCell>
              {revenueCagr[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {revenueGrowth[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {grossMargin[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitdaMargin[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitaMargin[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRowStrong>
            <TableCellTitleStrong>Total Average</TableCellTitleStrong>

            <StyledTableCell>
              {revenueCagr[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {revenueGrowth[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {grossMargin[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitdaMargin[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitaMargin[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRowStrong>
          <StyledTableRowStrong>
            <TableCellTitleStrong>Total Median</TableCellTitleStrong>

            <StyledTableCell>
              {revenueCagr[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {revenueGrowth[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {grossMargin[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitdaMargin[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitaMargin[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRowStrong>
          <TableRow>
            <TableCellTitle>Issuer</TableCellTitle>
            <StyledTableCell>
              {revenueCagr[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {revenueGrowth[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {grossMargin[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitdaMargin[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {ebitaMargin[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br />
      <hr />
      <br />
      {/* TABLE 2 */}
      <Table
        aria-label="customized table"
        className={classes.table}
        size="small">
        <TableHead>
          <StyledTableRow>
            <StyledTableCellStrong align="left">PEER</StyledTableCellStrong>
            {MEASUREMENTS_PEER_OP_METRICS2.map((measure) => (
              <StyledTableCellStrong align="center">
                {measure}
              </StyledTableCellStrong>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <TableCellTitle align="center" />
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>Lyft</TableCellTitle>
            <StyledTableCell>
              {nopatMargin[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {capexRevenue[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {wrcRevenue[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {netDebtEbitda[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {unleveredFcf[0].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>Uber Technologies</TableCellTitle>
            <StyledTableCell>
              {nopatMargin[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {capexRevenue[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {wrcRevenue[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {netDebtEbitda[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {unleveredFcf[1].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRowStrong>
            <TableCellTitleStrong>Total Average</TableCellTitleStrong>

            <StyledTableCell>
              {nopatMargin[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {capexRevenue[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {grossMargin[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {netDebtEbitda[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {unleveredFcf[2].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRowStrong>
          <StyledTableRowStrong>
            <TableCellTitleStrong>Total Median</TableCellTitleStrong>

            <StyledTableCell>
              {nopatMargin[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {capexRevenue[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {wrcRevenue[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {netDebtEbitda[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {unleveredFcf[3].map((val) => (
                <StyledTableCellStrong>{val}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRowStrong>
          <TableRow>
            <TableCellTitle>Issuer</TableCellTitle>
            <StyledTableCell>
              {nopatMargin[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {capexRevenue[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {wrcRevenue[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {netDebtEbitda[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {unleveredFcf[4].map((val) => (
                <StyledTableCell>{val}</StyledTableCell>
              ))}
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const mapStateToProps = (state) => ({
  dataSet: state.AuthReducer.dataSet
});

export const mapDispatchToProps = (dispatch) => {
  return {
    switchData: () => dispatch(switchDataSet())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableIncome);
